var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmojiError2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FF49A1",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hole"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.3384,25.8242a1,1,0,0,0,1.4145,0l.7664-.7667.7663.7667A1,1,0,0,0,6.7007,24.41l-.7672-.7676.7672-.7676a1,1,0,0,0-1.4151-1.4141l-.7663.7668-.7664-.7668a1,1,0,0,0-1.415,1.4141l.7672.7676-.7672.7676A1,1,0,0,0,2.3384,25.8242Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.98,40.2405a23.9922,23.9922,0,0,0-47.9607,0C2.7753,42.0383,0,44.3694,0,47c0,3.7141,5.3953,6.4485,12.9129,8.1108.0118.0025.0227.0057.0345.0076A91.8345,91.8345,0,0,0,32,57c15.5127,0,32-3.5049,32-10C64,44.37,61.2246,42.0372,55.98,40.2405ZM13.7349,53.2578a22,22,0,1,1,36.53,0A88.4654,88.4654,0,0,1,32,55,88.4654,88.4654,0,0,1,13.7349,53.2578Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,22.0039a3.001,3.001,0,1,0-3-3.001A3.0041,3.0041,0,0,0,53,22.0039Zm0-4.0019a1.001,1.001,0,1,1-1,1.0009A1.0018,1.0018,0,0,1,53,18.002Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 11.0005,
    r: 1.0002
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5,28.0078A7.503,7.503,0,1,0,49,35.5107,7.51,7.51,0,0,0,41.5,28.0078Zm0,13.0059a5.503,5.503,0,1,1,5.5-5.503A5.5078,5.5078,0,0,1,41.5,41.0137Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 34.8918,
    r: 1.5004
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,35.5107a7.5,7.5,0,1,0-7.5,7.503A7.51,7.51,0,0,0,30,35.5107Zm-7.5,5.503a5.503,5.503,0,1,1,5.5-5.503A5.5078,5.5078,0,0,1,22.5,41.0137Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5,33.3926A1.5007,1.5007,0,1,0,25,34.8933,1.5,1.5,0,0,0,23.5,33.3926Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0176,45c-3.5547,0-6.8062,1.3965-8.4864,3.6436A2.7448,2.7448,0,0,0,25.707,53H38.3193a2.652,2.652,0,0,0,2.3975-1.5215,2.8063,2.8063,0,0,0-.33-2.9863C38.6792,46.3379,35.4722,45,32.0176,45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9048,28.3867a1.001,1.001,0,0,0,1.272-.6181c1.19-3.4375,5.3671-3.2286,5.542-3.2129A1,1,0,0,0,23.85,22.56c-2.0132-.127-6.2065.6416-7.5625,4.5547A1,1,0,0,0,16.9048,28.3867Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2988,24.5557c.0469-.0069,4.3394-.25,5.5391,3.2129a1,1,0,1,0,1.89-.6543C46.3726,23.2012,42.1816,22.43,40.165,22.56a1,1,0,0,0-.9306,1.0654A1.0158,1.0158,0,0,0,40.2988,24.5557Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,14a1,1,0,0,0,1-1V9a1,1,0,0,0-2,0v4A1,1,0,0,0,32,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,15a.9967.9967,0,0,0,.707-.293l2.5-2.5a1,1,0,0,0-1.414-1.414l-2.5,2.5A1,1,0,0,0,36,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.793,14.707a1,1,0,0,0,1.414-1.414l-2.5-2.5a1,1,0,0,0-1.414,1.414Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiError2);
export default __webpack_public_path__ + "static/media/emojiError2.a3bb327e92424dd802f5e3c683600ff4.svg";
export { ForwardRef as ReactComponent };